<div *ngIf="(_loader.loaderState | async)?.show" class="loader-container">
    <div class="loader-wheel"></div>
</div>